import template from './step-banner.jade';

export default angular
  .module('app.directives.step-banner', [])
  .directive('stepBanner', $sce => ({
    restrict: 'E',
    template,
    scope: {
      text: '=bannerText',
    },
    link(scope, element, attrs) {
      /**
       * Expose SCE for html binding
       * @type {Object}
       */
      scope.sce = $sce;
    },
  }));
